import React, { Fragment } from 'react';
import { TargetIcon, PenToolIcon, LayoutTemplateIcon, ArrowDownIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const flow = [{
  icon: TargetIcon,
  label: 'GPT 1',
  sub: 'Define tu oferta'
}, {
  icon: PenToolIcon,
  label: 'GPT 2',
  sub: 'Escribe tu copy'
}, {
  icon: LayoutTemplateIcon,
  label: 'GPT 3',
  sub: 'Construye tu página'
}];
export function RevelationSection() {
  return <section className="w-full bg-zinc-950 py-12 sm:py-24" data-id="element-145">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-146">
        <Reveal data-id="element-147">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-orange-500" data-id="element-148">
            Presentamos
          </p>
          <h2 className="mt-3 font-display text-3xl text-white sm:text-5xl" data-id="element-149">
            <span className="text-glow-orange text-orange-500" data-id="element-150">
              LAUNCH MACHINE
            </span>{' '}
            AI
          </h2>
        </Reveal>

        <Reveal delay={0.05} data-id="element-151">
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-zinc-300 sm:text-lg" data-id="element-152">
            No es otro curso de ChatGPT. Es un{' '}
            <span className="font-semibold text-white" data-id="element-153">
              Ecosistema de 8 Especialistas Digitales
            </span>{' '}
            entrenados con las mejores estrategias de respuesta directa del
            mundo.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-154">
          <div className="mt-12 rounded-3xl border border-orange-500/20 bg-black/40 p-6 sm:p-10" data-id="element-155">
            <p className="text-sm font-bold uppercase tracking-wide text-amber-400" data-id="element-156">
              La magia
            </p>
            <p className="mx-auto mt-2 max-w-xl text-zinc-300" data-id="element-157">
              Los GPTs están interconectados. La salida de uno construye al
              siguiente. Una línea de ensamblaje automatizada para tu éxito.
            </p>

            <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center" data-id="element-158">
              {flow.map(({
              icon: Icon,
              label,
              sub
            }, i) => <Fragment key={label} data-id="element-159">
                  <div className="flex-1 rounded-2xl border border-zinc-800 bg-zinc-900 p-5" data-id="element-160">
                    <Icon className="mx-auto h-8 w-8 text-orange-500" aria-hidden="true" data-id="element-161" />
                    <p className="mt-3 font-display text-lg text-white" data-id="element-162">
                      {label}
                    </p>
                    <p className="text-xs text-zinc-400" data-id="element-163">{sub}</p>
                  </div>
                  {i < flow.length - 1 && <ArrowDownIcon className="mx-auto h-6 w-6 shrink-0 text-orange-500 sm:-rotate-90" aria-hidden="true" data-id="element-164" />}
                </Fragment>)}
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}